/**
 * @file ListItem.jsx
 * @author Daniel Aguirre
 * @description ListItem Page
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

function ListItem({ icon, body, options, link, onClick }) {
  const component = (
    <div
      onClick={() => (onClick ? onClick() : null)}
      style={{ border: 'solid 1px var(--color-grayBorders)' }}
      className="mb-3 p-2 rounded-md flex flex-wrap justify-between items-center">
      {<div className="w-9 text-left">{icon}</div>}
      <div className="text-left text-baxterGray w-52 iphoneRegular:w-60 md:w-10/12 md:pl-2">
        {body}
      </div>
      <div className="text-right w-10">
        {options || (
          <ArrowRightOutlined
            style={{
              fontSize: 16,
              color: 'var(--color-place-holder)',
              textAlign: 'right'
            }}
          />
        )}
      </div>
    </div>
  );
  return link ? <Link to={link}>{component}</Link> : component;
}

/**
 * Component definition of proptypes.
 */
ListItem.propTypes = {
  icon: PropTypes.element.isRequired,
  body: PropTypes.element.isRequired,
  options: PropTypes.element,
  link: PropTypes.string,
  onClick: PropTypes.func
};
export default ListItem;
